export { FeatureSpecFacade } from './lib/feature-spec-facade.service';
